import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFollowerLoss = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "15px",
	height: "12px",
	viewBox: "0 0 15 12",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Group 4" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Design",
			stroke: "none",
			strokeWidth: 1,
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Overview",
				transform: "translate(-754.000000, -1634.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-Copy-9",
					transform: "translate(730.000000, 1614.000000)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group-4",
						transform: "translate(24.000000, 20.000000)",
						children: [/* @__PURE__ */ _jsx("path", {
							d: "M0.0273626774,11.9997656 C-0.0333419361,11.320095 0,10.6596426 0.198460623,10.0240333 C0.322213657,9.62748063 0.638158904,9.37084636 1.02512152,9.24920874 C1.57591627,9.07600991 2.14077387,8.94851306 2.69391244,8.7823453 C3.02204548,8.6834415 3.35486614,8.57610041 3.66143616,8.42329169 C4.35707822,8.07665965 4.47192478,7.57581268 4.14824497,6.86028352 C3.78940805,6.06717816 3.45846243,5.25626074 3.18728391,4.42917185 C2.9390747,3.67309682 2.92946509,2.88444448 3.13337634,2.10047951 C3.42752418,0.966601342 4.26566973,0.204667085 5.42421376,0.0452960313 C6.26399998,-0.0702479825 7.06558213,0.0155311434 7.77880275,0.533955806 C8.84195381,1.30737415 9.04094307,2.41922162 8.91719003,3.62294181 C8.80210909,4.74135162 8.3989742,5.77913842 7.87888332,6.7684108 C7.4335599,7.61518671 7.60114214,8.15329838 8.48569508,8.50274285 C9.0625061,8.73008097 9.67470861,8.86484326 10.2707388,9.041792 C10.5154323,9.11468082 10.7692667,9.16835137 11.0013036,9.27100508 C11.4522522,9.47021889 11.7848385,9.78802352 11.8406211,10.3155886 C11.8989819,10.8682312 11.945858,11.4220456 12,12 L0.0273626774,12 L0.0273626774,11.9997656 Z",
							id: "Path",
							fillRule: "nonzero"
						}), /* @__PURE__ */ _jsx("path", {
							d: "M9,2.5 L13,2.5 C13.8284271,2.5 14.5,3.17157288 14.5,4 C14.5,4.82842712 13.8284271,5.5 13,5.5 L9,5.5 C8.17157288,5.5 7.5,4.82842712 7.5,4 C7.5,3.17157288 8.17157288,2.5 9,2.5 Z",
							id: "Combined-Shape",
							stroke: "#FFFFFF"
						})]
					})
				})
			})
		})
	]
});
export default SvgFollowerLoss;
